import { render } from "./mvt-schoolmarker.vue?vue&type=template&id=215e78d2"
import script from "./mvt-schoolmarker.js?vue&type=script&lang=js"
export * from "./mvt-schoolmarker.js?vue&type=script&lang=js"

import "./mvt-schoolmarker.vue?vue&type=style&index=0&id=215e78d2&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__